import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:px-6 px-4 py-6" }
const _hoisted_2 = { class: "relative mt-1" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ml-3 block truncate" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]

import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/24/solid";
import { ref, onMounted, PropType, computed, Ref } from "vue";
import Modal from "shared/components/modals/Modal.vue";
import { useTrackEvent } from "shared/composables/tracking";

type Language = { id: number; name: string; identifier: string; icon: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsLanguage',
  props: {
  open: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ["closeSettingsLanguage"],
  setup(__props) {





const languages: Language[] = [
  { id: 1, name: "Deutsch", identifier: "de", icon: "de" },
  { id: 2, name: "English", identifier: "en", icon: "gb" },
  { id: 3, name: "Français", identifier: "fr", icon: "fr" },
];

const currentLang: string = localStorage.getItem("lang") || "de";
const selected: Ref<Language> = ref(
  languages.find((lang) => lang.identifier === currentLang) || languages[0],
);
const trackEvent = useTrackEvent();

const changeLanguage = (language: Language) => {
  localStorage.setItem("lang", language.identifier);
  trackEvent("user_language-change_apply");
  window.location.reload();
};

const getImage = computed(() => {
  return require(`@/assets/imgs/flag_icons/${selected.value?.icon}.svg`);
});

onMounted(() => {
  if (!selected.value) {
    selected.value = languages[0];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: __props.open,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeSettingsLanguage'))),
    class: "h-max"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("admin.settings.language.title")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Listbox), {
          as: "div",
          modelValue: selected.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
          class: "lg:w-96 w-64 cursor-pointer"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ListboxLabel), { class: "block text-sm font-medium text-gray-700" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("admin.settings.language.language_choice")), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ListboxButton), { class: "focus:outline-none relative w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-yellow-300 focus:ring-1 focus:ring-yellow-300 sm:text-sm" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("img", {
                      src: getImage.value,
                      alt: "",
                      class: "h-6 w-6 flex-shrink-0"
                    }, null, 8, _hoisted_4),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(selected.value.name), 1)
                  ]),
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_unref(ChevronUpDownIcon), {
                      class: "h-5 w-5 text-gray-400",
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ListboxOptions), { class: "focus:outline-none absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-gray-800 ring-opacity-5 sm:text-sm" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (language) => {
                        return _createVNode(_unref(ListboxOption), {
                          as: "template",
                          key: language.id,
                          value: language
                        }, {
                          default: _withCtx(({ active, selected }) => [
                            _createElementVNode("li", {
                              class: _normalizeClass([
                      selected ? 'text-black bg-yellow-100' : 'text-gray-900',
                      'relative select-none py-2 pl-3 pr-9 hover:bg-yellow-100',
                    ])
                            }, [
                              _createElementVNode("div", {
                                class: "flex items-center",
                                onClick: ($event: any) => (changeLanguage(language))
                              }, [
                                _createElementVNode("img", {
                                  src: require(`@/assets/imgs/flag_icons/${language.icon}.svg`),
                                  alt: "",
                                  class: "h-6 w-6 flex-shrink-0"
                                }, null, 8, _hoisted_8),
                                _createElementVNode("span", {
                                  class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate'])
                                }, _toDisplayString(language.name), 3)
                              ], 8, _hoisted_7),
                              selected
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass([
                        active ? 'text-black' : 'text-yellow-600',
                        'absolute inset-y-0 right-0 flex items-center pr-4',
                      ])
                                  }, [
                                    _createVNode(_unref(CheckIcon), {
                                      class: "h-5 w-5",
                                      "aria-hidden": "true"
                                    })
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})